export default "__VITE_ASSET__CAjC317d__"